import { render } from "./EmptyFieldsDropZone.vue?vue&type=template&id=39dd6e46&scoped=true"
import script from "./EmptyFieldsDropZone.vue?vue&type=script&lang=js"
export * from "./EmptyFieldsDropZone.vue?vue&type=script&lang=js"

import "./EmptyFieldsDropZone.vue?vue&type=style&index=0&id=39dd6e46&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.30.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39dd6e46"]])

export default __exports__